import React from 'react';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';
import { ButtonProps } from '../types';
import './floatButton.scss';

type Props = {
  transparent?: boolean;
} & ButtonProps;

export const FloatButton: React.FC<Props> = ({ title, className, transparent, ...rest }) => {
  const classes = classnames(
    'smooth-background',
    {
      'is-desktop': !isMobile,
      'is-desktop__left': !isMobile && transparent,
    },
    className,
  );
  const floatButtonClasses = classnames('float-button', {
    'float-button--transparent': transparent,
  });
  return (
    <div className={classes}>
      <button className={floatButtonClasses} {...rest}>
        {title}
      </button>
    </div>
  );
};
